import React from 'react'
import PropTypes from 'prop-types'

const LogoIcon = React.memo(({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="37" viewBox="0 0 34 37">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_8" data-name="Rectangle 8" width="17" height="9" transform="translate(-4028 -18184)" fill="#fff"/>
        </clipPath>
        <clipPath id="clip-path-2">
          <rect id="Rectangle_9" data-name="Rectangle 9" width="17" height="5" transform="translate(-4045 -18212)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="amorim-loading" transform="translate(4045 18212)">
        <path id="_" data-name="(" d="M259.148,76.363v.632C254.84,78,253,81.705,253,86.731s1.838,8.731,6.146,9.737V97.1c-2.528-.316-9.593-2.643-9.593-10.369S256.62,76.679,259.148,76.363Z" transform="translate(-4289.039 -18281.24)" fill="#fff"/>
        <path id="_2" data-name=")" d="M302.869,86.731c0,7.726-7.066,10.053-9.593,10.369v-.632c4.308-1.005,6.118-4.71,6.118-9.737s-1.809-8.731-6.118-9.736v-.632C295.8,76.679,302.869,79.005,302.869,86.731Z" transform="translate(-4320.668 -18281.24)" fill="#fff"/>
        <g id="Mask_Group_10" data-name="Mask Group 10" clipPath="url(#clip-path)">
          <path id="_3" data-name=")" d="M302.869,86.731c0,7.726-7.066,10.053-9.593,10.369v-.632c4.308-1.005,6.118-4.71,6.118-9.737s-1.809-8.731-6.118-9.736v-.632C295.8,76.679,302.869,79.005,302.869,86.731Z" transform="translate(-4320.668 -18281.24)" fill="#fff"/>
        </g>
        <g id="Mask_Group_11" data-name="Mask Group 11" clipPath="url(#clip-path-2)">
          <path id="_4" data-name="(" d="M259.148,76.363v.632C254.84,78,253,81.705,253,86.731s1.838,8.731,6.146,9.737V97.1c-2.528-.316-9.593-2.643-9.593-10.369S256.62,76.679,259.148,76.363Z" transform="translate(-4289.039 -18281.24)" fill="#fff"/>
        </g>
      </g>
    </svg>
  )
})

LogoIcon.propTypes = {
  fill: PropTypes.string
}

LogoIcon.defaultProps = {
  fill: "#FFF"
}

export {LogoIcon}